import { defineComponent as _defineComponent } from 'vue'
import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, unref as _unref, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, resolveDirective as _resolveDirective, withDirectives as _withDirectives, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, createBlock as _createBlock, createTextVNode as _createTextVNode } from "vue"

const _hoisted_1 = { class: "pt md:min-h-screen flex flex-col" }
const _hoisted_2 = { class: "flex-1 flex flex-col md:flex-row" }
const _hoisted_3 = { class: "w-full md:w-1/2 bg-black flex items-center order-2 md:order-1" }
const _hoisted_4 = { class: "px-6 py-12 md:py-0 md:px-12 max-w-2xl mx-auto text-center md:text-left" }
const _hoisted_5 = { class: "text-4xl md:text-6xl font-bold text-white mb-8" }
const _hoisted_6 = { class: "text-xl text-white mb-10" }
const _hoisted_7 = { class: "w-full md:w-1/2 h-[400px] md:h-screen relative overflow-hidden order-1 md:order-2" }
const _hoisted_8 = ["src"]
const _hoisted_9 = { class: "py-20 bg-black" }
const _hoisted_10 = { class: "container mx-auto px-6 grid grid-cols-1 md:grid-cols-2 gap-2" }
const _hoisted_11 = { class: "md:h-[800px] overflow-hidden" }
const _hoisted_12 = ["alt"]
const _hoisted_13 = { class: "p-6" }
const _hoisted_14 = { class: "text-xl font-bold text-white mb-2" }
const _hoisted_15 = { class: "py-20 bg-white" }
const _hoisted_16 = { class: "container mx-auto px-6 grid grid-cols-1 md:grid-cols-3 gap-20" }
const _hoisted_17 = { class: "overflow-hidden" }
const _hoisted_18 = ["alt"]
const _hoisted_19 = { class: "p-6" }
const _hoisted_20 = { class: "text-xl font-bold text-black mb-2" }
const _hoisted_21 = { class: "pt md:min-h-screen flex flex-col" }
const _hoisted_22 = { class: "flex flex-col md:flex-row md:relative" }
const _hoisted_23 = { class: "w-full md:h-screen md:absolute overflow-hidden" }
const _hoisted_24 = ["src"]
const _hoisted_25 = { class: "flex md:justify-center md:items-center md:h-screen z-10 w-full" }
const _hoisted_26 = { class: "px-6 py-12 md:py-12 md:px-24 max-w-2xl mx-auto text-center bg-black md:mt-48 w-full md:w-auto md:rounded-2xl shadow-xl" }
const _hoisted_27 = { class: "text-4xl md:text-4xl font-bold text-white mb-8" }
const _hoisted_28 = {
  id: "equipment",
  class: "py-6 bg-white"
}
const _hoisted_29 = { class: "container mx-auto px-6" }
const _hoisted_30 = { class: "relative" }
const _hoisted_31 = { class: "bg-white rounded-lg overflow-hidden shadow-md hover:shadow-xl transition-all duration-300 h-full" }
const _hoisted_32 = { class: "h-64 overflow-hidden" }
const _hoisted_33 = ["alt"]
const _hoisted_34 = { class: "p-6" }
const _hoisted_35 = { class: "text-xl font-bold text-gray-800 mb-2" }
const _hoisted_36 = ["title"]
const _hoisted_37 = { class: "flex justify-between items-center" }
const _hoisted_38 = { class: "text-xl font-bold text-blue-800" }
const _hoisted_39 = { class: "py-6 bg-white" }
const _hoisted_40 = { class: "container mx-auto px-6 grid grid-cols-1 md:grid-cols-3" }
const _hoisted_41 = { class: "overflow-hidden md:col-span-2" }
const _hoisted_42 = ["src"]
const _hoisted_43 = { class: "py-6 bg-white" }
const _hoisted_44 = { class: "container mx-auto px-6 grid grid-cols-1 md:grid-cols-3" }
const _hoisted_45 = { class: "overflow-hidden md:col-span-2 order-1 md:order-2" }
const _hoisted_46 = ["src"]
const _hoisted_47 = { class: "py-20 bg-black" }
const _hoisted_48 = { class: "container mx-auto px-6 grid grid-cols-1 md:grid-cols-2 gap-2" }
const _hoisted_49 = { class: "md:h-86 overflow-hidden" }
const _hoisted_50 = {
  class: "w-full h-full object-cover object-top transition-transform duration-500 hover:scale-105",
  src: "data:image/gif;base64,R0lGODlhAQABAAAAACH5BAEKAAEALAAAAAABAAEAAAICTAEAOw=="
}
const _hoisted_51 = { class: "p-6" }
const _hoisted_52 = { class: "text-xl font-bold text-white mb-2" }
const _hoisted_53 = {
  id: "community",
  class: "py-20 bg-gray-50"
}
const _hoisted_54 = { class: "container mx-auto px-6" }
const _hoisted_55 = { class: "grid grid-cols-2 md:grid-cols-4 gap-4 mb-16" }
const _hoisted_56 = {
  alt: "社区照片",
  class: "w-full h-full object-cover object-top transition-transform duration-500 hover:scale-105",
  src: "data:image/gif;base64,R0lGODlhAQABAAAAACH5BAEKAAEALAAAAAABAAEAAAICTAEAOw=="
}
const _hoisted_57 = { class: "grid grid-cols-1 md:grid-cols-3 gap-8" }
const _hoisted_58 = { class: "bg-white rounded-lg p-8 text-center shadow-md" }
const _hoisted_59 = { class: "text-4xl font-bold text-blue-800 mb-2" }
const _hoisted_60 = { class: "bg-white rounded-lg p-8 text-center shadow-md" }
const _hoisted_61 = { class: "text-4xl font-bold text-blue-800 mb-2" }
const _hoisted_62 = { class: "bg-white rounded-lg p-8 text-center shadow-md" }
const _hoisted_63 = { class: "text-4xl font-bold text-blue-800 mb-2" }

import { ref, onMounted } from "vue";
import { getCodeImg } from "@/api/realhome";

// 从API导入模拟数据
import { featuredProducts, canvasBags, equipments, communityPhotos, communityStats, racingCars } from '@/api/home'


import { Swiper, SwiperSlide } from "swiper/vue";
import SwiperCore, { Pagination, Autoplay } from "swiper";
// 注册模块（Swiper 9 必须）
import "swiper/css";
import "swiper/css/pagination";
import "swiper/css/autoplay";
// swiper

export default /*@__PURE__*/_defineComponent({
  __name: 'Home',
  setup(__props) {

SwiperCore.use([Pagination, Autoplay]);
// 引入样式
const swiperModules = [Pagination, Autoplay];

// 主视觉横幅图片
const heroImage = require('@/assets/ncoreimg/homeImg.jpg');

// 定义响应式数据变量
const featuredProductsData = ref([]);
const canvasBagsData = ref([]);
const equipmentsData = ref([]);
const communityPhotosData = ref([]);
const communityStatsData = ref({});
const racingCarsData = ref([]);
const dataLoading = ref(true);

// 异步获取所有数据
const fetchAllData = async () => {
  try {
    // 并行请求所有数据
    const [featured, bags, equip, photos, stats, cars] = await Promise.all([
      featuredProducts(),
      canvasBags(),
      equipments(),
      communityPhotos(),
      communityStats(),
      racingCars()
    ]);
    
    // 更新响应式数据
    featuredProductsData.value = featured;
    canvasBagsData.value = bags;
    equipmentsData.value = equip;
    communityPhotosData.value = photos;
    communityStatsData.value = stats;
    racingCarsData.value = cars;
  } catch (error) {
    console.error('Failed to fetch home data:', error);
  } finally {
    dataLoading.value = false;
  }
};

// 组件挂载时获取数据
onMounted(() => {
  fetchAllData();
});

onMounted(() => {
  // 这段代码的主要功能是根据用户在页面上的滚动位置动态地为导航栏添加或移除阴影效果。具体来说，
  // 当页面的垂直滚动距离大于 100 像素时，导航栏会显示一个中等大小的阴影，使其在页面滚动时更加突出，
  // 提升用户体验。当滚动距离小于或等于 100 像素时，阴影效果会被移除，从而使页面顶部看起来更加简洁。
  // window.addEventListener("scroll", () => {
  //   const nav = document.querySelector("nav");
  //   if (window.scrollY > 100) {
  //     nav?.classList.add("shadow-md");
  //   } else {
  //     nav?.classList.remove("shadow-md");
  //   }
  // });
});


// 定义响应式变量 后期请求后端数据的测试方案
const loading = ref(false)
const queryParams = ref({}) // 根据实际需求初始化查询参数
const jobList = ref([])
const total = ref(0)

// 定义获取列表数据的方法
const getCode = async () => {
  loading.value = true
  try {
    const response = await getCodeImg()
    console.log(response)
  } finally {
    // 无论成功失败都关闭加载状态
    loading.value = false
  }
}
// getCode()

return (_ctx: any,_cache: any) => {
  const _component_router_link = _resolveComponent("router-link")!
  const _directive_lazy_load = _resolveDirective("lazy-load")!

  return (_openBlock(), _createElementBlock("div", null, [
    _createElementVNode("div", _hoisted_1, [
      _createElementVNode("div", _hoisted_2, [
        _createElementVNode("div", _hoisted_3, [
          _createElementVNode("div", _hoisted_4, [
            _createElementVNode("h1", _hoisted_5, _toDisplayString(_ctx.$t('company.slogan')), 1),
            _createElementVNode("p", _hoisted_6, _toDisplayString(_ctx.$t('company.describe')), 1)
          ])
        ]),
        _createElementVNode("div", _hoisted_7, [
          _createElementVNode("img", {
            src: _unref(heroImage),
            alt: "骑行场景",
            class: "w-full h-full object-cover object-center"
          }, null, 8, _hoisted_8)
        ])
      ])
    ]),
    _createElementVNode("section", _hoisted_9, [
      _createElementVNode("div", _hoisted_10, [
        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(featuredProductsData.value, (product, index) => {
          return (_openBlock(), _createElementBlock("div", {
            key: index,
            class: "relative"
          }, [
            _createElementVNode("div", _hoisted_11, [
              _withDirectives(_createElementVNode("img", {
                class: "w-full h-full object-cover object-top transition-transform duration-500 hover:scale-105",
                alt: product.title,
                src: "data:image/gif;base64,R0lGODlhAQABAAAAACH5BAEKAAEALAAAAAABAAEAAAICTAEAOw=="
              }, null, 8, _hoisted_12), [
                [_directive_lazy_load, product.image]
              ])
            ]),
            _createElementVNode("div", _hoisted_13, [
              _createElementVNode("h3", _hoisted_14, _toDisplayString(product.title), 1),
              _createVNode(_component_router_link, {
                to: { path: `/product/${product.id}`, query: { type: 'bikeormore' } },
                class: "inline-block"
              }, {
                default: _withCtx(() => _cache[0] || (_cache[0] = [
                  _createElementVNode("button", { class: "text-white mb-4" }, " 更多详情 → ", -1)
                ])),
                _: 2,
                __: [0]
              }, 1032, ["to"])
            ])
          ]))
        }), 128))
      ])
    ]),
    _createElementVNode("section", _hoisted_15, [
      _createElementVNode("div", _hoisted_16, [
        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(canvasBagsData.value, (bag, index) => {
          return (_openBlock(), _createElementBlock("div", {
            key: index,
            class: "relative"
          }, [
            _createElementVNode("div", _hoisted_17, [
              _withDirectives(_createElementVNode("img", {
                class: "w-full h-full object-cover object-top transition-transform duration-500 hover:scale-105",
                alt: bag.title,
                src: "data:image/gif;base64,R0lGODlhAQABAAAAACH5BAEKAAEALAAAAAABAAEAAAICTAEAOw=="
              }, null, 8, _hoisted_18), [
                [_directive_lazy_load, bag.image]
              ])
            ]),
            _createElementVNode("div", _hoisted_19, [
              _createElementVNode("h3", _hoisted_20, _toDisplayString(bag.title), 1),
              _createVNode(_component_router_link, {
                to: { path: `/product/${bag.id}`, query: { type: 'bikeormore' } },
                class: "inline-block"
              }, {
                default: _withCtx(() => _cache[1] || (_cache[1] = [
                  _createElementVNode("button", { class: "text-black mb-4" }, " 更多详情 → ", -1)
                ])),
                _: 2,
                __: [1]
              }, 1032, ["to"])
            ])
          ]))
        }), 128))
      ])
    ]),
    _createElementVNode("div", _hoisted_21, [
      _createElementVNode("div", _hoisted_22, [
        _createElementVNode("div", _hoisted_23, [
          _createElementVNode("img", {
            src: require('@/assets/ncoreimg/home2.jpg'),
            alt: "骑行场景",
            class: "w-full h-full object-cover object-center"
          }, null, 8, _hoisted_24)
        ]),
        _createElementVNode("div", _hoisted_25, [
          _createElementVNode("div", _hoisted_26, [
            _createElementVNode("h1", _hoisted_27, _toDisplayString(_ctx.$t('company.slogan')), 1)
          ])
        ])
      ])
    ]),
    _createElementVNode("section", _hoisted_28, [
      _createElementVNode("div", _hoisted_29, [
        _createElementVNode("div", _hoisted_30, [
          _createVNode(_unref(Swiper), {
            modules: swiperModules,
            "slides-per-view": 1,
            "space-between": 20,
            pagination: { clickable: true },
            autoplay: { delay: 5000, disableOnInteraction: false },
            breakpoints: {
              '640': {
                slidesPerView: 2,
                spaceBetween: 20,
              },
              '1024': {
                slidesPerView: 3,
                spaceBetween: 30,
              },
            }
          }, {
            default: _withCtx(() => [
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(equipmentsData.value, (equipment, index) => {
                return (_openBlock(), _createBlock(_unref(SwiperSlide), { key: index }, {
                  default: _withCtx(() => [
                    _createElementVNode("div", _hoisted_31, [
                      _createElementVNode("div", _hoisted_32, [
                        _withDirectives(_createElementVNode("img", {
                          alt: equipment.name,
                          class: "w-full h-full object-cover object-top transition-transform duration-500 hover:scale-105",
                          src: "data:image/gif;base64,R0lGODlhAQABAAAAACH5BAEKAAEALAAAAAABAAEAAAICTAEAOw=="
                        }, null, 8, _hoisted_33), [
                          [_directive_lazy_load, equipment.image]
                        ])
                      ]),
                      _createElementVNode("div", _hoisted_34, [
                        _createElementVNode("h3", _hoisted_35, _toDisplayString(equipment.name), 1),
                        _createElementVNode("p", {
                          class: "text-gray-600 mb-4 line-clamp-2-min-h-2-line",
                          title: equipment.description
                        }, _toDisplayString(equipment.description), 9, _hoisted_36),
                        _createElementVNode("div", _hoisted_37, [
                          _createElementVNode("span", _hoisted_38, _toDisplayString(equipment.price), 1),
                          _createVNode(_component_router_link, {
                            to: { path: `/product/${equipment.id}`, query: { type: 'bikeormore' } },
                            class: "inline-block"
                          }, {
                            default: _withCtx(() => _cache[2] || (_cache[2] = [
                              _createElementVNode("button", { class: "bg-blue-800 hover:bg-blue-700 text-white px-4 py-2 rounded text-sm font-medium transition-all duration-300 cursor-pointer !rounded-button whitespace-nowrap" }, " 更多详情 → ", -1)
                            ])),
                            _: 2,
                            __: [2]
                          }, 1032, ["to"])
                        ])
                      ])
                    ])
                  ]),
                  _: 2
                }, 1024))
              }), 128))
            ]),
            _: 1
          })
        ])
      ])
    ]),
    _createElementVNode("section", _hoisted_39, [
      _createElementVNode("div", _hoisted_40, [
        _createElementVNode("div", _hoisted_41, [
          _createElementVNode("img", {
            src: require('@/assets/nhomebody/long-left.png'),
            class: "w-full h-full min-h-full object-cover transition-transform duration-500 hover:scale-105"
          }, null, 8, _hoisted_42)
        ]),
        _cache[3] || (_cache[3] = _createElementVNode("div", { class: "p-6 bg-black md:col-span-1 flex flex-col justify-center" }, [
          _createElementVNode("h3", { class: "text-xl font-bold text-white mb-2" }, " 城市周末休闲骑行集结 "),
          _createElementVNode("p", { class: "text-white mb-4" }, [
            _createTextVNode("我们定期组织城市绿道短途休闲骑行活动，面向所有日常通勤、休闲骑行爱好者，全程路线平缓、里程适中。出行前会统一讲解骑行安全要点、沿途补给点位， "),
            _createElementVNode("br"),
            _createTextVNode("也会同步分享配件日常调试、胎压把控、简单故障自查的实用技巧，大家可结伴结伴出行，交流日常骑行的装备使用心得。")
          ])
        ], -1))
      ])
    ]),
    _createElementVNode("section", _hoisted_43, [
      _createElementVNode("div", _hoisted_44, [
        _createElementVNode("div", _hoisted_45, [
          _createElementVNode("img", {
            src: require('@/assets/nhomebody/long-right.png'),
            class: "w-full h-full min-h-full object-cover transition-transform duration-500 hover:scale-105"
          }, null, 8, _hoisted_46)
        ]),
        _cache[4] || (_cache[4] = _createElementVNode("div", { class: "p-6 bg-black md:col-span-1 order-2 md:order-1 flex flex-col justify-center" }, [
          _createElementVNode("h3", { class: "text-xl font-bold text-white mb-2" }, " 郊野路线骑行体验出行 "),
          _createElementVNode("p", { class: "text-white mb-4" }, [
            _createTextVNode("针对偏好户外越野、长途骑行的骑友，定期规划郊野成熟骑行路线组织集体出行。"),
            _createElementVNode("br"),
            _createTextVNode("活动全程会安排随行装备技术指引，讲解越野路况下护具、刹车、避震类配件的适配选择与出行前检查事项，大家可结伴探索户外骑行路线，互相交流长途装备搭配、路况应对的经验，全程无打卡评奖环节，主打结伴安全骑行、经验交流。")
          ])
        ], -1))
      ])
    ]),
    _createElementVNode("section", _hoisted_47, [
      _createElementVNode("div", _hoisted_48, [
        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(racingCarsData.value, (car) => {
          return (_openBlock(), _createElementBlock("div", {
            key: car.id,
            class: "relative"
          }, [
            _createElementVNode("div", _hoisted_49, [
              _withDirectives(_createElementVNode("img", _hoisted_50, null, 512), [
                [_directive_lazy_load, car.image]
              ])
            ]),
            _createElementVNode("div", _hoisted_51, [
              _createElementVNode("h3", _hoisted_52, _toDisplayString(car.title), 1),
              _createVNode(_component_router_link, {
                to: { path: `/product/${car.id}`, query: { type: 'bikeormore' } },
                class: "inline-block"
              }, {
                default: _withCtx(() => _cache[5] || (_cache[5] = [
                  _createElementVNode("button", { class: "text-white mb-4" }, " 更多详情 → ", -1)
                ])),
                _: 2,
                __: [5]
              }, 1032, ["to"])
            ])
          ]))
        }), 128))
      ])
    ]),
    _createElementVNode("section", _hoisted_53, [
      _createElementVNode("div", _hoisted_54, [
        _cache[9] || (_cache[9] = _createElementVNode("h2", { class: "text-3xl md:text-4xl font-bold text-center text-gray-800 mb-4" }, " 我们的骑行社区 ", -1)),
        _cache[10] || (_cache[10] = _createElementVNode("p", { class: "text-center text-gray-600 mb-16 max-w-3xl mx-auto" }, " 加入北境骑团，与志同道合的伙伴一起探索骑行的无限可能。 ", -1)),
        _createElementVNode("div", _hoisted_55, [
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(communityPhotosData.value, (photo, index) => {
            return (_openBlock(), _createElementBlock("div", {
              key: index,
              class: "overflow-hidden rounded-lg h-48 md:h-64"
            }, [
              _withDirectives(_createElementVNode("img", _hoisted_56, null, 512), [
                [_directive_lazy_load, photo]
              ])
            ]))
          }), 128))
        ]),
        _createElementVNode("div", _hoisted_57, [
          _createElementVNode("div", _hoisted_58, [
            _createElementVNode("div", _hoisted_59, _toDisplayString(communityStatsData.value.totalDistance), 1),
            _cache[6] || (_cache[6] = _createElementVNode("p", { class: "text-gray-600" }, "累计骑行里程", -1))
          ]),
          _createElementVNode("div", _hoisted_60, [
            _createElementVNode("div", _hoisted_61, _toDisplayString(communityStatsData.value.activeMembers), 1),
            _cache[7] || (_cache[7] = _createElementVNode("p", { class: "text-gray-600" }, "活跃会员数", -1))
          ]),
          _createElementVNode("div", _hoisted_62, [
            _createElementVNode("div", _hoisted_63, _toDisplayString(communityStatsData.value.completedRoutes), 1),
            _cache[8] || (_cache[8] = _createElementVNode("p", { class: "text-gray-600" }, "完成路线数", -1))
          ])
        ])
      ])
    ])
  ]))
}
}

})